import { useHandler } from "@redotech/react-util/hook";
import { useLocalStorage } from "usehooks-ts";

export interface UseConversationViewLayoutResult {
  leftPanelOpen: boolean;
  setLeftPanelOpen: (open: boolean) => void;
  toggleLeftPanel: () => void;
  rightPanelOpen: boolean;
  setRightPanelOpen: (open: boolean) => void;
  toggleRightPanel: () => void;
}

export function useConversationViewLayout(): UseConversationViewLayoutResult {
  const [leftPanelOpen, setLeftPanelOpen] = useLocalStorage<boolean>(
    "redo.support-v2.conversation-detail.left-panel-open",
    true,
  );

  const [rightPanelOpen, setRightPanelOpen] = useLocalStorage<boolean>(
    "redo.support-v2.conversation-detail.right-panel-open",
    true,
  );

  const toggleLeftPanel = useHandler(() => setLeftPanelOpen(!leftPanelOpen));
  const toggleRightPanel = useHandler(() => setRightPanelOpen(!rightPanelOpen));

  return {
    leftPanelOpen,
    setLeftPanelOpen,
    toggleLeftPanel,
    rightPanelOpen,
    setRightPanelOpen,
    toggleRightPanel,
  };
}
